import Http from '@/utils/http';
import { AppResponse, ISeasonShardingReportResponse } from '@/types';

// 获取学生考季切片报告
export const getSeasonShardingReport = (params: {
    projectId: number;
    courseId?: number;
}): Promise<AppResponse<ISeasonShardingReportResponse>> => Http.get('/student-learning/front/report/season-sharding', params);
